import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Config, IonicModule, ModalController, ToastController } from '@ionic/angular';
import { AuthService } from '../../_services/auth.service';
import { BadgeService } from '../../_services/badge.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatrixService } from '../../_services/matrix.service';
import { BleDevice } from '@capacitor-community/bluetooth-le';

@Component({
    selector: 'app-badge',
    templateUrl: 'badge.modal.html',
    styleUrls: ['./badge.modal.scss'],
    standalone: true,
    imports: [
        CommonModule,
        IonicModule,
    ]
})
export class BadgeModal implements OnInit {

    available? : Subscription

    constructor(
        public ble : BadgeService,
        private cdr : ChangeDetectorRef,
        private modalC : ModalController,
        private matrix : MatrixService,
        private toast : ToastController
    ) {

    }   

    async ngOnInit(){
        await this.ble.init();
        this.ble.startScan();

        this.available = this.ble.available$.subscribe(available => {
            console.log("Available devices:", available);
            this.cdr.detectChanges();
        });
    }
    support(){
        this.modalC.dismiss();
        this.matrix.chatWithSupport();
    }

    connectToDevice(device : BleDevice){
        this.ble.connectToDevice(device).then((conn) => {
            console.log("Connected to device", conn);
            this.cdr.detectChanges();
            this.modalC.dismiss();
            this.toast.create({ header: `Connected to: ${device.name}`, message: device.deviceId, duration: 2000, color: 'success'}).then(t => t.present());
        })
    }

    tryLater(){
        this.modalC.dismiss();
    }

}
